import React from "react";
import PropTypes from 'prop-types';
import { Icon } from 'antd';

class ConfirmPopup extends React.Component {

    render() {
        return (
            <div className="p-2 deletePopup text-center">
                <h6 className="mb-4"><Icon type="question-circle" className="mr-2 color-red" />{this.props.message}</h6>
                <div className="d-flex m-auto deletePopup_buttons justify-content-center">
                    <button className="button-global button-border autoHeight mr-3 btn-lg btn-block" type="primary mr-3"
                        onClick={this.props.onCancel}>No</button>
                    <button className="button-global button-primary autoHeight  btn-lg btn-block m-0" type="primary"
                        onClick={() => this.props.onOk(this.props.popupData)}>Yes</button>
                </div>
            </div>
        );
    }
}

ConfirmPopup.propTypes = {
    onCancel: PropTypes.func,
    onDelete: PropTypes.func,
    message: PropTypes.string.isRequired,
    onOk: PropTypes.func
};

export default ConfirmPopup;